module.exports = __webpack_public_path__ + "img/kitkitphoto14.f5896511.jpg";